import { render, staticRenderFns } from "./TasksView.vue?vue&type=template&id=3e68dd5f&"
import script from "./TasksView.vue?vue&type=script&lang=js&"
export * from "./TasksView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports